/* US DRAWER - motor del carrito lateral propio (1-oct-2026). Sustituye a Monster Cart.
   - El estado sale siempre de /cart.js (y la primera vez, del carrito que pinta Liquid).
   - Intercepta: submit de form[action*="/cart/add"], form.submit(), fetch y XHR a /cart/*,
     clics en enlaces a /cart (icono de la cabecera) y #cart en la URL.
   - Regalo automatico, franja por linea, checkbox de la guia y Savings como Monster.
   Config: snippets/us-drawer.liquid (bloque CONFIGURACION). */
(function () {
  'use strict';
  if (window.usDrawer) return;
  var raiz = document.getElementById('usd');
  var nodoCfg = document.getElementById('usd-config');
  if (!raiz || !nodoCfg) return;
  var C;
  try { C = JSON.parse(nodoCfg.textContent); } catch (e) { return; }

  var T = C.t || {};
  var R = C.rutas || {};
  var raizUrl = R.raiz || '/';
  var urlAdd = (R.add || '/cart/add') + '.js';
  var urlChange = (R.change || '/cart/change') + '.js';
  var urlUpdate = (R.update || '/cart/update') + '.js';
  var urlCart = (R.carrito || '/cart') + '.js';
  var setCampana = {}; (C.regalo.campana || []).forEach(function (h) { setCampana[h] = true; });
  var setFranja = {}; (C.franja.campana || []).forEach(function (h) { setFranja[h] = true; });

  var panel = raiz.querySelector('.usd-panel');
  var lista = raiz.querySelector('[data-usd-lista]');
  var nCab = raiz.querySelector('[data-usd-n]');
  var ahorroFila = raiz.querySelector('[data-usd-ahorro]');
  var ahorroN = raiz.querySelector('[data-usd-ahorro-n]');
  var total = raiz.querySelector('[data-usd-total]');
  var guiaInput = raiz.querySelector('[data-usd-guia]');
  var pagar = raiz.querySelector('[data-usd-pagar]');
  var aviso = raiz.querySelector('[data-usd-aviso]');

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var E = {
    carrito: C.carrito || { items: [], item_count: 0, total_price: 0, total_discount: 0 },
    productos: {},        // handle -> { v: [{id, t, p, c, a}] }
    abierto: false,
    ocupado: 0,
    anadiendo: 0,
    error: '',
    regaloFallo: false,
    disparador: null,
    scrollY: 0,
    burbujaN: null
  };
  Object.keys(C.productos || {}).forEach(function (h) { E.productos[h] = C.productos[h]; });
  E.burbujaN = E.carrito.item_count;

  /* ---------------- utilidades ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dinero(cents) {
    var fmt = C.moneda || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    function con(dec, miles, punto) {
      var p = v.toFixed(dec).split('.');
      var ent = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return ent + (p[1] ? punto + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return con(0, ',', '.');
      if (k === 'amount_with_comma_separator') return con(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return con(0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return con(2, "'", '.');
      return con(2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esRegalo(it) { return it.handle === C.regalo.handle; }
  function esGuia(it) { return it.handle === C.guia.handle; }
  function variante(it) {
    var p = E.productos[it.handle];
    if (!p) return null;
    for (var i = 0; i < p.v.length; i++) if (p.v[i].id === it.variant_id) return p.v[i];
    return null;
  }
  function api(url, cuerpo) {
    var op = { method: cuerpo ? 'POST' : 'GET', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };
    if (cuerpo instanceof FormData) op.body = cuerpo;
    else if (cuerpo) { op.headers['Content-Type'] = 'application/json'; op.body = JSON.stringify(cuerpo); }
    return nativeFetch(url, op).then(function (r) {
      return r.text().then(function (txt) {
        var j = null, mal = false;
        try { j = txt ? JSON.parse(txt) : null; } catch (e) { mal = true; }
        if (!r.ok || mal) { var err = new Error('cart'); err.datos = j; err.estado = r.status; throw err; }
        return j;
      });
    });
  }
  function textoError(e) {
    var d = e && e.datos;
    var m = d && (d.description || d.message);
    if (m && typeof m === 'string' && m.length < 200) return m;
    return T.error;
  }

  /* ---------------- datos ---------------- */
  function leerCarrito() {
    return api(urlCart + '?_=' + Date.now()).then(function (c) {
      if (!c || !c.items) throw new Error('cart');
      E.carrito = c;
      E.leido = Date.now();
      return c;
    });
  }
  function cargarProductos() {
    var faltan = [];
    E.carrito.items.forEach(function (it) {
      if (!E.productos[it.handle] && faltan.indexOf(it.handle) < 0) faltan.push(it.handle);
    });
    if (!faltan.length) return Promise.resolve();
    return Promise.all(faltan.map(function (h) {
      return api(raizUrl + 'products/' + encodeURIComponent(h) + '.js').then(function (p) {
        E.productos[h] = { v: (p.variants || []).map(function (v) {
          return { id: v.id, t: v.title, p: v.price, c: v.compare_at_price || 0, a: !!v.available };
        }) };
      }).catch(function () { E.productos[h] = { v: [] }; });
    }));
  }
  // el globo de la cabecera (Dawn: seccion cart-icon-bubble) viaja en la misma respuesta del cambio
  function conSecc(o) { o.sections = 'cart-icon-bubble'; o.sections_url = location.pathname; return o; }
  function ponerBurbuja(html) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sec = doc.querySelector('.shopify-section') || doc.body;
    el.innerHTML = sec.innerHTML;
    var n = el.querySelector('.cart-count-bubble span[aria-hidden]');
    E.burbujaN = n ? (parseInt(n.textContent, 10) || 0) : 0;
  }
  // respuesta de change/update = carrito entero (se usa tal cual); la de add = lineas (hay que leer el carrito)
  function aplicar(r) {
    if (r && r.sections && r.sections['cart-icon-bubble']) ponerBurbuja(r.sections['cart-icon-bubble']);
    if (r && r.items && typeof r.item_count === 'number') {
      var c = {}; Object.keys(r).forEach(function (k) { if (k !== 'sections') c[k] = r[k]; });
      E.carrito = c;
      E.leido = Date.now();
      return true;
    }
    return false;
  }
  function burbuja() {
    var n = E.carrito.item_count;
    if (n === E.burbujaN) return;
    E.burbujaN = n;
    nativeFetch(raizUrl + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) { if (s && s['cart-icon-bubble']) ponerBurbuja(s['cart-icon-bubble']); })
      .catch(function () {});
  }

  /* regalo y guia: se ajustan solos despues de cada cambio (como Monster) */
  function sincronizar() {
    var c = E.carrito;
    var reales = c.items.filter(function (it) { return !esRegalo(it) && !esGuia(it); });
    var enCampana = 0;
    reales.forEach(function (it) { if (setCampana[it.handle]) enCampana += it.quantity; });
    var regalos = c.items.filter(esRegalo);
    var guias = c.items.filter(esGuia);
    var updates = {}, hay = false, anadirRegalo = false;

    if (!reales.length) {
      regalos.concat(guias).forEach(function (it) { updates[it.key] = 0; hay = true; });
    } else {
      if (enCampana >= (C.regalo.meta || 1)) {
        if (!regalos.length) anadirRegalo = !E.regaloFallo && !!C.regalo.variante;
        else regalos.forEach(function (it, i) {
          var q = i === 0 ? 1 : 0;
          if (it.quantity !== q) { updates[it.key] = q; hay = true; }
        });
      } else {
        regalos.forEach(function (it) { updates[it.key] = 0; hay = true; });
      }
      guias.forEach(function (it, i) {
        var q = i === 0 ? 1 : 0;
        if (it.quantity !== q) { updates[it.key] = q; hay = true; }
      });
    }
    if (!hay && !anadirRegalo) return Promise.resolve();
    var paso = Promise.resolve(null);
    if (hay) paso = paso.then(function () { return api(urlUpdate, conSecc({ updates: updates })); });
    if (anadirRegalo) {
      paso = paso.then(function () {
        return api(urlAdd, conSecc({ items: [{ id: C.regalo.variante, quantity: 1, properties: { _free_gift: 'auto' } }] }))
          .then(function (r) { aplicar(r); return null; }, function () { E.regaloFallo = true; return null; });
      });
    }
    return paso.then(function (r) { if (!aplicar(r)) return leerCarrito(); });
  }

  // r = respuesta de la operacion (si ya trae el carrito entero no se vuelve a pedir)
  function refrescar(r) {
    return (aplicar(r) ? Promise.resolve() : leerCarrito()).then(sincronizar).then(cargarProductos).then(function () {
      pintar(); burbuja();
    });
  }

  /* cola: una operacion detras de otra (nada de clics que se pisan) */
  var cola = Promise.resolve();
  function encolar(fn) {
    E.ocupado++; marcarOcupado();
    var p = cola.then(fn).then(function (r) { E.error = ''; return r; }, function (e) { E.error = textoError(e); return null; })
      .then(function (r) { return refrescar(r).catch(function () {}); })
      .then(function () { E.ocupado--; marcarOcupado(); try { pintar(); } catch (e) {} });
    cola = p;
    return p;
  }
  function marcarOcupado() {
    raiz.classList.toggle('is-busy', E.ocupado > 0 && E.anadiendo === 0);
    if (pagar) pagar.setAttribute('aria-disabled', E.ocupado > 0 ? 'true' : 'false');
  }

  /* ---------------- pintar ---------------- */
  var ICO = {
    papelera: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>',
    menos: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/></svg>',
    mas: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    flecha: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>',
    ok: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    regalo: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    bolsa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l1 14H5L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>'
  };

  function esqueleto() {
    return '<div class="usd-linea usd-esq" aria-hidden="true">' +
      '<div class="usd-linea__foto"></div>' +
      '<div class="usd-linea__info">' +
        '<span class="usd-esq__b" style="width:72%;height:18px"></span>' +
        '<span class="usd-esq__b" style="width:60%;height:26px"></span>' +
        '<span class="usd-esq__b" style="width:100%;height:26px"></span>' +
      '</div></div>';
  }

  function linea(it) {
    var v = variante(it);
    var p = E.productos[it.handle];
    if (!p) return esqueleto();
    var gratis = it.final_line_price === 0 && it.price === 0;
    var antes = v && v.c ? v.c * it.quantity : 0;
    var tachado = antes > it.final_line_price ? antes : (it.original_line_price > it.final_line_price ? it.original_line_price : 0);
    var h = '<div class="usd-linea" data-usd-linea="' + esc(it.key) + '">';
    h += '<span class="usd-linea__foto">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" width="88" height="88" loading="lazy">' : '') + '</span>';
    h += '<div class="usd-linea__info">';
    h += '<div class="usd-linea__fila1"><a class="usd-linea__titulo" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
      '<button type="button" class="usd-linea__quitar" data-usd-acc="quitar" aria-label="' + esc(T.quitar + ': ' + it.product_title) + '">' + ICO.papelera + '</button></div>';
    if (p.v.length > 1) {
      h += '<label class="usd-var"><span class="usd-sr">' + esc(T.opcion) + '</span><select data-usd-acc="variante">';
      p.v.forEach(function (x) {
        var t = String(x.t).replace(/\s{2,}/g, ' ');
        h += '<option value="' + x.id + '"' + (x.id === it.variant_id ? ' selected' : '') + (!x.a && x.id !== it.variant_id ? ' disabled' : '') + '>' + esc(t + (!x.a ? ' - ' + T.agotado : '')) + '</option>';
      });
      h += '</select>' + ICO.flecha + '</label>';
    }
    h += '<div class="usd-linea__fila3"><p class="usd-precio">';
    if (gratis) h += '<span class="usd-precio__gratis">' + esc(T.gratis) + '</span>';
    else {
      if (tachado) h += '<s class="usd-precio__antes">' + dinero(tachado) + '</s>';
      h += '<span class="usd-precio__ahora">' + dinero(it.final_line_price) + '</span>';
    }
    h += '</p>';
    if (!gratis) {
      h += '<div class="usd-cant" role="group" aria-label="' + esc(T.cantidad) + '">' +
        '<button type="button" class="usd-cant__btn" data-usd-acc="menos" aria-label="' + esc(T.menos) + '">' + ICO.menos + '</button>' +
        '<span class="usd-cant__n" aria-live="polite">' + it.quantity + '</span>' +
        '<button type="button" class="usd-cant__btn" data-usd-acc="mas" aria-label="' + esc(T.mas) + '">' + ICO.mas + '</button></div>';
    }
    h += '</div></div>';
    if (setFranja[it.handle] && !gratis) {
      var txt = esc(T.franja).replace('[cantidad]', '<b>' + esc(T.franjaCantidad) + '</b>');
      h += '<p class="usd-franja"><span class="usd-franja__izq"><span class="usd-franja__ok">' + ICO.ok + '</span><span>' + txt + '</span></span>' +
        '<span class="usd-franja__cada">' + esc(T.franjaCada).replace('[precio]', dinero(it.price)) + '</span></p>';
    }
    h += '</div>';
    return h;
  }

  function bloqueRegalo(it) {
    var v = variante(it);
    var antes = v && v.c ? v.c : 0;
    var foto = it.image ? img(it.image, 160) : C.regalo.imagen;
    return '<div class="usd-regalo">' +
      '<p class="usd-regalo__tit">' + ICO.regalo + '<span>' + esc(T.regaloTitulo) + '</span></p>' +
      '<div class="usd-regalo__fila"><span class="usd-regalo__foto">' + (foto ? '<img src="' + esc(foto) + '" alt="" width="64" height="64" loading="lazy">' : '') +
      '<span class="usd-regalo__check">' + ICO.ok + '</span></span>' +
      '<div><p class="usd-regalo__nombre">' + esc(it.product_title) + '</p><p class="usd-regalo__precio">' +
      (antes ? '<s class="usd-precio__antes">' + dinero(antes) + '</s>' : '') +
      '<span class="usd-chip-verde">' + esc(T.regaloGratis) + '</span></p></div></div></div>';
  }

  /* upsell "compra frecuente" (Mystery Box): bajo los productos mientras no este en el carrito */
  function bloqueUpsell() {
    var u = C.upsell;
    if (!u || !u.variante) return '';
    if (E.carrito.items.some(function (it) { return it.handle === u.handle; })) return '';
    return '<div class="usd-up">' +
      '<p class="usd-up__tit"><span class="usd-up__tit-t">' + ICO.regalo + '<span class="usd-up__tit-l">' + esc(T.upsellTit) + '</span><span class="usd-up__tit-s">' + esc(T.upsellTitCorto) + '</span></span>' +
      (u.antes > u.precio ? '<span class="usd-up__chip">' + esc(T.upsellValor).replace('[valor]', dinero(u.antes)) + '</span>' : '') + '</p>' +
      '<div class="usd-up__fila"><a class="usd-up__foto" href="' + esc(u.url) + '" tabindex="-1" aria-hidden="true">' +
      (u.imagen ? '<img src="' + esc(u.imagen) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
      '<div class="usd-up__info"><a class="usd-up__nombre" href="' + esc(u.url) + '">' + esc(u.titulo) + '</a>' +
      '<p class="usd-up__txt">' + esc(T.upsellTxt) + '</p>' +
      '<p class="usd-precio">' + (u.antes > u.precio ? '<s class="usd-precio__antes">' + dinero(u.antes) + '</s>' : '') +
      '<span class="usd-precio__ahora">' + dinero(u.precio) + '</span></p></div>' +
      '<button type="button" class="usd-up__btn" data-usd-up>' + ICO.mas + '<span>' + esc(T.upsellBtn) + '</span></button></div></div>';
  }
  function anadirUpsell(btn) {
    if (!C.upsell || !C.upsell.variante || btn.disabled) return;
    btn.disabled = true;
    return encolar(function () {
      return api(urlAdd, conSecc({ items: [{ id: C.upsell.variante, quantity: 1 }] }));
    }).then(anunciar);
  }

  function pintar() {
    var c = E.carrito;
    var reales = c.items.filter(function (it) { return !esRegalo(it) && !esGuia(it); }).slice().reverse();
    var regalo = c.items.filter(esRegalo)[0];
    var guia = c.items.filter(esGuia)[0];
    var enCampana = 0;
    reales.forEach(function (it) { if (setCampana[it.handle]) enCampana += it.quantity; });
    var vacio = c.item_count === 0 && !E.anadiendo;

    // foco: se recuerda el control para devolverlo tras repintar
    var act = document.activeElement, focoKey = null, focoAcc = null;
    if (act && lista.contains(act)) {
      var l = act.closest('[data-usd-linea]');
      focoKey = l && l.getAttribute('data-usd-linea');
      focoAcc = act.getAttribute('data-usd-acc');
    }

    raiz.classList.toggle('is-empty', vacio);
    nCab.textContent = c.item_count;
    var h = '';
    if (vacio) {
      h = (E.error ? '<p class="usd-error" role="alert">' + esc(E.error) + '</p>' : '') + '<div class="usd-vacio"><span class="usd-vacio__ico">' + ICO.bolsa + '</span>' +
        '<p class="usd-vacio__tit">' + esc(T.vacio) + '</p>' +
        '<button type="button" class="usd-btn-sec" data-usd-cerrar>' + esc(T.seguir) + '</button></div>';
    } else {
      if (E.error) h += '<p class="usd-error" role="alert">' + esc(E.error) + '</p>';
      if (enCampana > 0) {
        var pct = Math.min(100, Math.round(enCampana / (C.regalo.meta || 1) * 100));
        h += '<div class="usd-barra" role="progressbar" aria-label="' + esc(T.progreso) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span class="usd-barra__in" style="width:' + pct + '%"></span></div>';
      }
      reales.forEach(function (it) { h += linea(it); });
      if (E.anadiendo) h += esqueleto();
      if (regalo && enCampana > 0) h += bloqueRegalo(regalo);
      h += bloqueUpsell();
    }
    lista.innerHTML = h;

    // pie
    var ahorro = c.total_discount || 0;
    c.items.forEach(function (it) {
      var v = variante(it);
      if (v && v.c > it.price) ahorro += (v.c - it.price) * it.quantity;
    });
    ahorroFila.hidden = !(ahorro > 0);
    ahorroN.textContent = '-' + dinero(ahorro);
    total.textContent = dinero(c.total_price);
    if (guiaInput) guiaInput.checked = !!guia;

    if (focoKey || focoAcc) {
      var sel = focoKey ? '[data-usd-linea="' + (window.CSS && CSS.escape ? CSS.escape(focoKey) : focoKey) + '"] ' : '';
      var el = lista.querySelector(sel + '[data-usd-acc="' + focoAcc + '"]');
      if (el) el.focus({ preventScroll: true });
    }
  }

  /* ---------------- abrir y cerrar ---------------- */
  function bloquear() {
    if (E.bloqueado) return;
    E.bloqueado = true;
    E.scrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    // sin la barra de scroll la pagina se correria a la derecha: se compensa con su ancho
    var barra = window.innerWidth - document.documentElement.clientWidth;
    E.estiloBody = [b.style.position, b.style.top, b.style.width, b.style.paddingRight];
    document.documentElement.classList.add('usd-bloqueo');
    if (barra > 0) b.style.paddingRight = barra + 'px';
    if (window.innerWidth <= 450) {
      b.style.position = 'fixed'; b.style.top = -E.scrollY + 'px'; b.style.width = '100%';
      E.fijo = true;
    }
  }
  function desbloquear() {
    if (!E.bloqueado) return;
    E.bloqueado = false;
    var b = document.body;
    document.documentElement.classList.remove('usd-bloqueo');
    b.style.position = E.estiloBody[0]; b.style.top = E.estiloBody[1]; b.style.width = E.estiloBody[2]; b.style.paddingRight = E.estiloBody[3];
    if (E.fijo) { E.fijo = false; window.scrollTo(0, E.scrollY); }
  }

  /* animacion: el panel entra con transform translateX(100%) -> 0 en .3 s ease-out y la capa funde su opacidad
     (CSS). Al abrir: visible y pintado ANTES de animar (el contenido ya esta cuando empieza a moverse). Al cerrar:
     se espera al transitionend del panel para ocultarlo y soltar el scroll (nada parpadea ni salta). */
  var finCierre = null, timerCierre = 0;
  function cancelarCierre() {
    if (finCierre) { panel.removeEventListener('transitionend', finCierre); finCierre = null; }
    clearTimeout(timerCierre);
  }
  function abrir(disparador) {
    if (!E.abierto) {
      E.abierto = true;
      cancelarCierre();
      E.disparador = disparador || document.activeElement;
      raiz.removeAttribute('inert');
      raiz.setAttribute('aria-hidden', 'false');
      bloquear();
      pintar();
      raiz.classList.add('is-visible');
      void panel.offsetWidth;            // fija la posicion de salida (fuera de pantalla) antes de animar
      requestAnimationFrame(function () {
        if (!E.abierto) return;
        raiz.classList.add('is-open');
        setTimeout(function () { var x = raiz.querySelector('.usd-cab__x'); if (x && E.abierto) x.focus({ preventScroll: true }); }, 320);
      });
    } else {
      pintar();
    }
    if (E.carrito.items.some(function (it) { return !E.productos[it.handle]; })) {
      cargarProductos().then(pintar);
    }
  }
  function cerrar() {
    if (!E.abierto) return;
    E.abierto = false;
    raiz.classList.remove('is-open');
    raiz.setAttribute('aria-hidden', 'true');
    if (location.hash === '#cart' && window.history && history.replaceState) {
      history.replaceState(history.state, '', location.pathname + location.search);
    }
    var d = E.disparador;
    E.disparador = null;
    cancelarCierre();
    finCierre = function (e) {
      if (e && (e.target !== panel || e.propertyName !== 'transform')) return;
      cancelarCierre();
      if (E.abierto) return;
      raiz.classList.remove('is-visible');
      raiz.setAttribute('inert', '');
      desbloquear();
      if (d && d.focus && document.contains(d)) { try { d.focus({ preventScroll: true }); } catch (x) {} }
    };
    panel.addEventListener('transitionend', finCierre);
    // respaldo por si no llega el transitionend; si la transicion sigue en marcha, se espera a que acabe
    var respaldo = function () {
      if (!finCierre) return;
      var vivas = panel.getAnimations ? panel.getAnimations().filter(function (a) { return a.playState === 'running'; }) : [];
      if (vivas.length) { timerCierre = setTimeout(respaldo, 100); return; }
      finCierre();
    };
    timerCierre = setTimeout(respaldo, 450);
  }

  /* ---------------- acciones ---------------- */
  function buscar(key) {
    var its = E.carrito.items;
    for (var i = 0; i < its.length; i++) if (its[i].key === key) return its[i];
    return null;
  }
  function cambiarCantidad(key, delta, fija) {
    return encolar(function () {
      var it = buscar(key);
      if (!it) return;
      var q = fija != null ? fija : Math.max(0, it.quantity + delta);
      return api(urlChange, conSecc({ id: key, quantity: q }));
    });
  }
  function cambiarVariante(key, nueva) {
    return encolar(function () {
      var it = buscar(key);
      if (!it || it.variant_id === nueva) return;
      var props = {};
      Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k] != null && it.properties[k] !== '') props[k] = it.properties[k]; });
      // primero la nueva (si no se puede, no se pierde la vieja) y luego se quita la vieja
      return api(urlAdd, { items: [{ id: nueva, quantity: it.quantity, properties: props }] }).then(function () {
        return api(urlChange, conSecc({ id: key, quantity: 0 }));
      });
    });
  }
  function guia(marcar) {
    return encolar(function () {
      var g = E.carrito.items.filter(esGuia);
      if (marcar && !g.length) return api(urlAdd, conSecc({ items: [{ id: C.guia.variante, quantity: 1 }] }));
      if (!marcar && g.length) {
        var u = {}; g.forEach(function (it) { u[it.key] = 0; });
        return api(urlUpdate, conSecc({ updates: u }));
      }
    });
  }

  /* anadir desde un formulario de producto (buybox, barra fija, ficha, ebook, home...) */
  function esFormAdd(f) {
    if (!f || f.nodeName !== 'FORM' || f.hasAttribute('data-usd-nativo')) return false;
    var a = f.getAttribute('action') || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(a);
  }
  function anadirForm(f, boton) {
    var fd;
    try { fd = boton ? new FormData(f, boton) : new FormData(f); } catch (e) { fd = new FormData(f); }
    fd.delete('sections'); fd.delete('sections_url');
    fd.append('sections', 'cart-icon-bubble'); fd.append('sections_url', location.pathname);
    if (!fd.get('id')) return;
    var botonDes = boton && !boton.disabled ? boton : null;
    if (botonDes) { botonDes.disabled = true; botonDes.setAttribute('aria-busy', 'true'); }
    E.anadiendo++;
    E.error = '';
    abrir(boton || f.querySelector('[type=submit]'));
    pintar();
    return encolar(function () {
      return api(urlAdd, fd);
    }).then(function () {
      E.anadiendo--; pintar();
      if (botonDes) { botonDes.disabled = false; botonDes.removeAttribute('aria-busy'); }
      anunciar();
    });
  }
  function anunciar() {
    if (aviso) aviso.textContent = T.titulo + ': ' + E.carrito.item_count;
  }

  /* ---------------- eventos ---------------- */
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!esFormAdd(f)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    anadirForm(f, e.submitter || null);
  }, true);

  var submitNativo = HTMLFormElement.prototype.submit;
  HTMLFormElement.prototype.submit = function () {
    if (esFormAdd(this)) { anadirForm(this, null); return; }
    return submitNativo.apply(this, arguments);
  };

  function esEnlaceCarrito(a) {
    if (!a || !a.getAttribute) return false;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    try {
      var u = new URL(href, location.href);
      if (u.origin !== location.origin) return false;
      var ruta = u.pathname.replace(/\/+$/, '');
      var rc = (R.carrito || '/cart').replace(/\/+$/, '');
      return ruta === rc || ruta === '/cart';
    } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented && !e.target.closest('#cart-icon-bubble')) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || raiz.contains(a) || !esEnlaceCarrito(a)) return;
    e.preventDefault();
    e.stopPropagation();
    abrir(a);
    // si lo ultimo leido tiene mas de 20 s (otra pestana, otra app), se vuelve a leer
    if (!E.leido || Date.now() - E.leido > 20000) refrescar().catch(function () {});
  }, true);

  raiz.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-usd-cerrar]')) { e.preventDefault(); cerrar(); return; }
    var up = t.closest('[data-usd-up]');
    if (up) { e.preventDefault(); anadirUpsell(up); return; }
    var b = t.closest('[data-usd-acc]');
    if (!b || b.nodeName === 'SELECT') return;
    var l = b.closest('[data-usd-linea]');
    if (!l) return;
    var key = l.getAttribute('data-usd-linea');
    var acc = b.getAttribute('data-usd-acc');
    if (acc === 'mas') cambiarCantidad(key, 1);
    else if (acc === 'menos') cambiarCantidad(key, -1);
    else if (acc === 'quitar') cambiarCantidad(key, 0, 0);
  });
  raiz.addEventListener('change', function (e) {
    var t = e.target;
    if (t === guiaInput) { guia(t.checked); return; }
    if (t.matches && t.matches('select[data-usd-acc="variante"]')) {
      var l = t.closest('[data-usd-linea]');
      if (l) cambiarVariante(l.getAttribute('data-usd-linea'), parseInt(t.value, 10));
    }
  });
  if (pagar) pagar.addEventListener('click', function (e) {
    if (E.ocupado > 0) { e.preventDefault(); }
  });

  // Esc y trampa de foco
  document.addEventListener('keydown', function (e) {
    if (!E.abierto) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); cerrar(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (x) {
      return x.offsetWidth > 0 || x.offsetHeight > 0 || x === guiaInput;
    });
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var primero = f[0], ultimo = f[f.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); primero.focus(); return; }
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });

  // otras piezas que tocan el carrito por su cuenta (GemPages, apps): se refresca y, si anadieron, se abre
  var RX_CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (nativeFetch) {
    window.fetch = function (entrada, op) {
      var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
      var p = nativeFetch(entrada, op);
      if (RX_CART.test(url)) {
        var add = /\/cart\/add/.test(url);
        p.then(function (r) {
          if (!r.ok) return;
          setTimeout(function () {
            encolar(function () {}).then(function () { if (add) abrir(); });
          }, 0);
        }).catch(function () {});
      }
      return p;
    };
  }
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this._usdUrl = String(url || ''); return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (RX_CART.test(x._usdUrl || '')) {
      x.addEventListener('load', function () {
        if (x.status < 200 || x.status >= 300) return;
        var add = /\/cart\/add/.test(x._usdUrl);
        encolar(function () {}).then(function () { if (add) abrir(); });
      });
    }
    return xSend.apply(this, arguments);
  };

  // #cart abre el drawer en cualquier pagina
  function mirarHash() { if (location.hash === '#cart') abrir(); }
  window.addEventListener('hashchange', mirarHash);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refrescar().catch(function () {}); });

  window.usDrawer = {
    abrir: abrir, cerrar: cerrar, refrescar: refrescar,
    estado: function () { return E; }
  };
  // nombres que usan otras piezas para abrir un carrito lateral
  if (!window.openCart) window.openCart = function () { abrir(); };

  // si all_products no dio la variante del regalo o de la guia (limite de 20 por pagina), se pide aparte
  [C.regalo, C.guia].forEach(function (o) {
    if (o.variante || !o.handle) return;
    api(raizUrl + 'products/' + encodeURIComponent(o.handle) + '.js').then(function (p) {
      var v = (p.variants || [])[0];
      if (v) o.variante = v.id;
      E.productos[o.handle] = { v: (p.variants || []).map(function (x) { return { id: x.id, t: x.title, p: x.price, c: x.compare_at_price || 0, a: !!x.available }; }) };
    }).catch(function () {});
  });

  mirarHash();
  if (E.carrito.item_count > 0) {
    // carrito ya con cosas: estado fresco, regalo y guia al dia
    setTimeout(function () { refrescar().catch(function () {}); }, 400);
  }
})();
